import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './MyrAlerts.translations.json';
import { Alert } from 'antd';
import * as Icon from 'react-feather';
import React, { FC, useMemo } from 'react';

const { addTranslations, useTranslation } = i18nNsFactory('myr-spinner');
addTranslations(translations);

interface MyrSpinnerProps {
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
}

export const MyrAlerts: FC<MyrSpinnerProps> = ({
  isFetching,
  isSuccess,
  isError,
}) => {
  const { t } = useTranslation();

  const alertType = useMemo(
    () => (isSuccess ? 'success' : 'error'),
    [isSuccess]
  );

  const alertMessage = useMemo(
    () => t(isSuccess ? 'alert.myr-success' : 'alert.myr-error'),
    [isSuccess, t]
  );

  const alertIcon = useMemo(
    () => (isSuccess ? <Icon.Check /> : <Icon.AlertTriangle />),
    [isSuccess]
  );

  if (isFetching || !(isSuccess || isError)) {
    return;
  }

  return (
    <Alert
      type={alertType}
      message={alertMessage}
      icon={alertIcon}
      banner
      closable
    />
  );
};
